import { Injectable } from "@angular/core";

import { CarouselData } from "@core/models/carousel-data";
import { Observable, Subject } from "rxjs";

@Injectable()
export class FileService {

	public fileCarousel: CarouselData[];

	private fileAddedSubject = new Subject<CarouselData>();
	private fileDeletedSubject = new Subject<any>();

	constructor() {

		this.fileCarousel = new Array<CarouselData>();
	}

	public onFileAdded(): Observable<CarouselData> {

		return this.fileAddedSubject.asObservable();
	}

	public onFileDeleted(): Observable<any> {

		return this.fileDeletedSubject.asObservable();
	}

	getFiles(): CarouselData[] {

		return this.fileCarousel;
	}

	addFile(carouselData: CarouselData) {

		this.fileCarousel.unshift(carouselData);
		this.fileAddedSubject.next(carouselData);
	}

	deleteFile(carouselId: any) {

		const fileIndex = this.fileCarousel.findIndex(x => x.id == carouselId);
		if (fileIndex != -1) {

			this.fileCarousel.splice(fileIndex, 1);
			this.fileDeletedSubject.next(carouselId);
		}
	}
}